import { useContext } from 'react';
import FilterSetForm from '../FilterSetForm';
import FilterSetsList from '../FilterSetsList.js';
import useSelectedFilterSet from '../../../../hooks/useSelectedFilterSet';
import { size } from 'lodash';
import { CloseIcon, CopyIcon, ListIcon, SaveIcon } from '@linearb/linui-common';
import useEventsTracker from '../../tracking/useEventsTracker';
import { getFilterSetTypeText } from '../filter-set.utils';
import { FILTER_SET_MODEL } from '../FilterSet.model';
import useContextActions from '../../../../useContextActions';

export const FILTER_SET_MENU_KEYS = {
  SAVE: 'save_filter_set',
  DUPLICATE: 'duplicate_filter_set',
  VIEW: 'view_filter_set',
  CLEAR: 'clear_filter_set'
};

const useMenuItems = Context => {
  const selectedFilterSet = useSelectedFilterSet(Context);
  const {
    state: { localFilters },
    modalHandler
  } = useContext(Context);
  const contextActions = useContextActions({ Context });
  const eventsTracker = useEventsTracker({ Context });

  const isSaveFiltersEnabled = !selectedFilterSet && size(localFilters) > 0;

  const isDuplicateFiltersEnabled = !!selectedFilterSet;

  const menuItems = [
    isSaveFiltersEnabled && {
      key: FILTER_SET_MENU_KEYS.SAVE,
      label: 'Save Filter',
      Icon: SaveIcon,
      onClick: () => {
        eventsTracker.onSelectFilterSetMenuOption.save();
        modalHandler.openModal({
          content: () => (
            <FilterSetForm
              Context={Context}
              filterSet={selectedFilterSet}
              onSubmit={modalHandler.closeModal}
            />
          ),
          stickToTop: true
        });
      }
    },
    isDuplicateFiltersEnabled && {
      key: FILTER_SET_MENU_KEYS.DUPLICATE,
      label: `Duplicate Current ${getFilterSetTypeText(selectedFilterSet)} `,
      Icon: CopyIcon,
      onClick: () => {
        eventsTracker.onSelectFilterSetMenuOption.save();
        modalHandler.openModal({
          content: () => (
            <FilterSetForm
              Context={Context}
              filterSet={{
                ...selectedFilterSet,
                id: null,
                name: `Copy of ${selectedFilterSet[FILTER_SET_MODEL.NAME]}`
              }}
              onSubmit={modalHandler.closeModal}
            />
          ),
          stickToTop: true
        });
      }
    },
    {
      key: FILTER_SET_MENU_KEYS.VIEW,
      label: 'View and Manage Filters',
      Icon: ListIcon,
      onClick: () => {
        eventsTracker.onSelectFilterSetMenuOption.manage();
        modalHandler.openModal({
          content: () => (
            <FilterSetsList
              Context={Context}
              onSelect={modalHandler.closeModal}
              onClose={modalHandler.closeModal}
            />
          ),
          stickToTop: true
        });
      }
    },
    {
      key: FILTER_SET_MENU_KEYS.CLEAR,
      label: 'Clear Filters',
      Icon: CloseIcon,
      onClick: () => {
        eventsTracker.onSelectFilterSetMenuOption.clear();
        contextActions.onClearFilterSet();
      }
    }
  ].filter(Boolean);
  return menuItems;
};

export default useMenuItems;
